import { API_KEY, API_URL, RES_PER_PAGE } from "./config";
import { AJAX } from "./helpers";
export const state = {
  recipe:
  {},
  search:
  {
    query: "",
    results: [],
    currentPage: 1,
    resultsPerPage: RES_PER_PAGE
  },
  bookmarks: []
};
const createRecipeData = function(data)
{
  const {recipe} = data.data;
  return state.recipe = {
    id: recipe.id,
    publisher: recipe.publisher,
    ingredients: recipe.ingredients,
    sourceUrl: recipe.source_url,
    imageUrl: recipe.image_url,
    title: recipe.title,
    servings: recipe.servings,
    cookingTime: recipe.cooking_time,
    ...(recipe.key && {key:recipe.key})
  };
}
export const getRecipe = async function(id)
{
  try
  {
    const data = await AJAX(`${API_URL}/${id}?key=${API_KEY}`);
    state.recipe = createRecipeData(data);
    if (state.bookmarks.some(recipe => id === recipe.id))
    {
      state.recipe.bookmarked = true;
    }
    else
    {
      state.recipe.bookmarked = false;
    }
  }
  catch (error)
  {
    throw error;
  }
};
export const loadSearchResults = async function(query)
{
  try
  {
    state.search.query = query;
    let data = await AJAX(`${API_URL}?search=${query}&key=${API_KEY}`);
    const recipes = data.data.recipes.map(recipe =>
    {
      return {
        id: recipe.id,
        image: recipe.image_url,
        title: recipe.title,
        publisher: recipe.publisher,
        ...(recipe.key && {key:recipe.key})
      };
    });
    state.search.results = recipes;
    state.search.currentPage = 1;
  }
  catch (error)
  {
    throw error;
  }
};
export const getPaginatedResults = function(page = state.search.currentPage)
{
  state.search.currentPage = page;
  const
  {
    resultsPerPage
  } = state.search;
  return state.search.results.slice((page - 1) * resultsPerPage, page * resultsPerPage);
};
export const updateServings = function(newServings)
{
  const
  {
    servings
  } = state.recipe;
  state.recipe.ingredients.forEach(ingredient =>
  {
    ingredient.quantity = (ingredient.quantity / servings) * newServings;
  });
  state.recipe.servings = newServings;
};
export const addBookmark = function(recipe)
{
  // Add Bookmark To State
  state.bookmarks.push(recipe);
  if (recipe.id === state.recipe.id)
    state.recipe.bookmarked = true;
  saveBookmarks();
};
export const removeBookmark = function(id)
{
  // Add Bookmark To State
  const index = state.bookmarks.findIndex(el => el.id === id);
  state.bookmarks.splice(index, 1);
  if (id === state.recipe.id)
    state.recipe.bookmarked = false;
  saveBookmarks();
};
const saveBookmarks = function()
{
  localStorage.setItem("bookmarks", JSON.stringify(state.bookmarks));
};
export const uploadRecipe = async function(recipe)
{
  try {
    const ingredients = Object.entries(recipe)
    .filter(entry => entry[0].startsWith("ingredient") && entry[1] !== "")
    .map(ing=>{
      const ingArr = ing[1].split(",").map(el=>el.trim);
      if(ingArr.length<3) throw new Error("Incorrect Ingredient Format");
      const [quantity,unit,description] = ingArr;
      return {quantity:quantity ? +quantity:null,unit,description}
    });
    const newRecipe =
    {
      title: recipe.title,
      source_url: recipe.sourceUrl,
      publisher: recipe.publisher,
      image_url: recipe.image,
      servings: +recipe.servings,
      cooking_time: +recipe.cookingTime,
      ingredients
    }
    data = await AJAX(`${API_URL}?key=${API_KEY}`,newRecipe);
    state.recipe = createRecipeData(data);
    addBookmark(state.recipe);
  } catch (error) {
    throw error;
  }
};
const init = function()
{
  // localStorage.clear("bookmarks");
  state.bookmarks = JSON.parse(localStorage.getItem("bookmarks"))??[];

};
init();
